import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { EditorData } from "../../state/IdentitySettings/EditorData";

const updateUserPermissionsEditorData: Reducer<EditorData> = (state: EditorData = new EditorData(), action: Action<ActionType, EditorData>) => {
  switch (action.type) {
    case ActionType.IDENTITY_SETTINGS_EDITOR_DATA_RESET:
      return new EditorData();
    case ActionType.IDENTITY_SETTINGS_EDITOR_DATA_FETCHED:
      return { ...state, identitySettingsData: action.data };
    case ActionType.IDENTITY_SETTINGS_EDITOR_DATA_COPIED:
      return { ...state, identitySettingsData: { ...action.data} };
    case ActionType.IDENTITY_SETTINGS_EDITOR_DATA_UPDATED:
      return { ...state, identitySettingsData: { ...state.identitySettingsData, ...action.data } };
    case ActionType.IDENTITY_SETTINGS_EDITOR_DATA_SAVED:
      return { ...state, readyToSave: false };
    case ActionType.IDENTITY_SETTINGS_EDITOR_DATA_VALIDATED:
      return { ...state, validation: action.data };
    case ActionType.IDENTITY_SETTINGS_EDITOR_BRAND_AND_MARKET_SET:
      return { ...state, identitySettingsData: {...state.identitySettingsData, brandAndMarket: action.data}};
    default:
      return state;
  }
};

export default updateUserPermissionsEditorData;
